import React from "react"
import Button from "@/components/core/Button/Button"
import styles from "./review.module.scss"
import { getTranslations } from "@/components/Returns/v1/localization"
import { useTranslation } from "next-i18next"

const Review = props => {
  const { t } = useTranslation("common")
  const staticText = getTranslations(t)
  return (
    <div className={styles.returnReview}>
      <div className="returnReview__details">
        <h3>{staticText.reviewDescription}</h3>
        <p>
          {staticText.reviewPara}
          <a>{staticText.reviewTerms} </a>
          {staticText.reviewParagraph} <a>{staticText.reviewPrivacy}</a>
        </p>
      </div>
      <div className="returnreview__submitbutton">
        <Button
          role="button"
          customClass="returnreview__submit"
          disabled={false}
          label={staticText.returnReviewSubmit}
          onClick={() => props.onReview()}
        />
      </div>
    </div>
  )
}

export default Review
